import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Roundtripcabnavimumbai() {



const cardData = {
  keyword: " Round Trip Cab Navi Mumbai",

headingDescription:
"Omshree Cab provides dependable and comfortable round-trip cab services in Navi Mumbai for travelers seeking convenient, hassle-free transportation for city travel, airport transfers, corporate outings, or leisure trips. Whether you are planning a family day out, a business meeting, or a sightseeing tour, our round-trip cab service ensures a smooth and safe journey with professional drivers and well-maintained vehicles. We offer flexible packages with hourly, daily, and multi-day options at transparent pricing with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from any location in Navi Mumbai, experienced chauffeurs familiar with city roads, and 24/7 customer support, Omshree Cab is your trusted partner for round-trip cab bookings in Navi Mumbai.",

topPlaces: [
{
title: "Central Park Kharghar",
description:
"Central Park Kharghar is one of Navi Mumbai’s largest and most beautiful urban parks, featuring landscaped gardens, walking trails, fountains, and recreational areas. Visitors can enjoy morning walks, jogging, picnics, or family outings. Booking a round-trip cab ensures travelers can spend ample time exploring this scenic park without worrying about local transportation or parking hassles."
},
{
title: "Palm Beach Road",
description:
"Palm Beach Road is a scenic and well-planned route connecting Vashi, Nerul, and Belapur, offering picturesque views of the waterfront and modern cityscape. It’s popular for leisurely drives, sightseeing, and photography. A round-trip cab provides a comfortable and stress-free way to enjoy this iconic road and its surroundings."
},
{
title: "Seawoods Grand Central Mall",
description:
"Seawoods Grand Central Mall is a premier shopping and entertainment destination in Navi Mumbai, featuring retail stores, restaurants, cafes, and a multiplex cinema. A round-trip cab ensures hassle-free transport, allowing visitors to shop, dine, and enjoy leisure activities without worrying about return travel or parking."
},
{
title: "Utsav Chowk",
description:
"Utsav Chowk in Kharghar is a well-known landmark famous for its architectural design and decorative fountains. Visitors often stop here for photography, casual strolls, or dining at nearby restaurants. Using a round-trip cab makes it easy to include this spot in your sightseeing itinerary comfortably."
},
{
title: "ISKCON Kharghar",
description:
"ISKCON Kharghar is a serene spiritual center dedicated to Lord Krishna, offering devotees and visitors a peaceful environment for prayers, meditation, and cultural programs. A round-trip cab allows travelers to conveniently visit this spiritual destination and return without transport concerns."
},
{
title: "Belapur Fort",
description:
"Belapur Fort is a historic site in Navi Mumbai with scenic surroundings, offering a glimpse into the region’s heritage. Travelers can enjoy photography, leisurely walks, and exploring the old fort structure. A round-trip cab ensures safe and convenient access for visitors."
},
{
title: "Nerul Balaji Temple",
description:
"Nerul Balaji Temple is a prominent religious site in Navi Mumbai, dedicated to Lord Venkateswara. Visitors come for darshan, prayers, and spiritual experiences. Booking a round-trip cab allows hassle-free transportation to this revered temple and back."
},
{
title: "Sagar Vihar",
description:
"Sagar Vihar is a calm and scenic waterfront promenade in Vashi, ideal for evening walks, family outings, and photography. Visitors enjoy views of the Thane Creek and peaceful ambiance. A round-trip cab ensures a comfortable ride for visiting this location and returning safely."
},
{
title: "Golf Course Kharghar",
description:
"The Kharghar Golf Course is a recreational area featuring open green fields, landscaped gardens, and scenic views. Visitors come for walking, leisure, and photography. A round-trip cab provides easy access and a comfortable journey to this outdoor destination."
},
{
title: "Pandavkada Waterfalls",
description:
"Pandavkada Waterfalls is a beautiful natural site near Kharghar, especially popular during the monsoon season. Tourists enjoy trekking, photography, and short nature walks. Using a round-trip cab ensures visitors can comfortably reach this refreshing location and return to Navi Mumbai without transport hassles."
}
],



services: [
{
name: "Round Trip Cab Navi Mumbai",
description: "Round trip cab Navi Mumbai service provides convenient two-way transportation for travelers planning return journeys. Whether you are traveling for business, family trips, or tourism, round trip cabs offer reliable and comfortable travel solutions. Our vehicles include sedans, SUVs, and premium MPV cars suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai locations. Passengers enjoy flexible travel schedules and comfortable seating during their journey. The service is ideal for outstation trips, temple visits, and weekend travel. Travelers can complete their trip and return comfortably with dependable cab service."
},
{
name: "Round Trip Taxi Navi Mumbai",
description: "Round trip taxi Navi Mumbai offers reliable transportation for passengers requiring return travel between cities. The taxi service provides comfortable vehicles with spacious seating and powerful AC for relaxed travel. Professional drivers ensure safe highway driving and punctual pickup services. Travelers can visit destinations like Pune, Nashik, Lonavala, Shirdi, and other cities conveniently. Families and groups enjoy comfortable travel without worrying about return transport. The service provides flexible travel duration based on customer needs. It ensures convenient and stress-free two-way transportation."
},
{
name: "Return Trip Cab Navi Mumbai",
description: "Return trip cab Navi Mumbai service allows passengers to travel to their destination and return in the same vehicle comfortably. The service is ideal for business meetings, family visits, and short outstation trips. Vehicles provide comfortable seating and smooth highway performance. Professional drivers ensure safe travel and convenient pickups throughout the journey. Passengers enjoy flexible schedules and reliable transportation. The service supports both short and long-distance travel. Travelers benefit from dependable round-trip cab services."
},
{
name: "Two Way Cab Navi Mumbai",
description: "Two way cab Navi Mumbai service provides comfortable intercity transportation for travelers planning return journeys. Vehicles offer spacious seating and reliable ride quality for long-distance travel. Professional drivers ensure punctual pickup services and safe driving throughout the trip. The service is suitable for business travel, family trips, and tourist journeys. Passengers can enjoy flexible travel timing for return journeys. Vehicles provide air-conditioned comfort and smooth highway travel. The service ensures convenient and reliable two-way transportation."
},
{
name: "Round Trip Taxi Booking Navi Mumbai",
description: "Round trip taxi booking Navi Mumbai allows travelers to reserve vehicles easily for return journeys. Customers can book sedans, SUVs, or MPV vehicles depending on group size and travel needs. Online and phone booking options provide quick confirmation and flexible travel planning. Professional drivers ensure safe driving and punctual pickup services. The service is suitable for business travel, pilgrimage tours, and family vacations. Vehicles provide comfortable interiors and smooth ride quality. Travelers enjoy convenient and reliable round-trip taxi booking."
},
{
name: "Navi Mumbai Round Trip Cab Service",
description: "Navi Mumbai round trip cab service offers dependable transportation for passengers traveling to nearby cities and returning the same day or later. The service includes comfortable vehicles suitable for both short and long-distance travel. Professional drivers ensure safe driving and timely pickups across Navi Mumbai areas. Passengers can travel to popular destinations like Pune, Lonavala, Nashik, or Shirdi easily. Vehicles provide comfortable seating and strong AC cooling. Families and business travelers enjoy reliable transportation throughout the journey. The service ensures smooth round-trip travel experiences."
},
{
name: "Cheap Round Trip Taxi Navi Mumbai",
description: "Cheap round trip taxi Navi Mumbai provides affordable two-way transportation for travelers seeking economical travel options. Customers can travel comfortably in well-maintained vehicles at competitive prices. The service offers comfortable seating and reliable ride quality for city and highway travel. Professional drivers ensure punctual pickup services and safe driving. The taxi is suitable for budget travelers, students, and families. Travelers enjoy economical fares with convenient travel schedules. The service ensures affordable round-trip transportation."
},
{
name: "Best Round Trip Cab Navi Mumbai",
description: "Best round trip cab Navi Mumbai service provides premium transportation with reliable vehicles and experienced drivers. Travelers receive punctual pickup services and comfortable ride experiences throughout the journey. Vehicles offer spacious seating and air-conditioned interiors for relaxed travel. The service is suitable for corporate travelers, families, and tourists. Professional drivers ensure safe driving and courteous service. Passengers enjoy flexible travel schedules for return journeys. It provides dependable and high-quality round-trip transportation."
},
{
name: "Innova Round Trip Cab Navi Mumbai",
description: "Innova round trip cab Navi Mumbai provides spacious MPV transportation ideal for families and groups traveling together. The Toyota Innova offers comfortable seating and smooth highway performance suitable for long journeys. Professional drivers ensure safe driving and convenient pickups throughout the trip. The vehicle provides ample luggage space and powerful AC for comfortable travel. Families and corporate groups enjoy relaxed travel experiences. The service is perfect for long-distance round-trip journeys. Travelers benefit from reliable and comfortable MPV transportation."
},
{
name: "Sedan Round Trip Taxi Navi Mumbai",
description: "Sedan round trip taxi Navi Mumbai offers economical sedan transportation for return journeys between cities. Vehicles like Swift Dzire and similar sedans provide smooth ride quality and comfortable seating for passengers. Professional drivers ensure punctual pickup services and safe highway driving. The service is ideal for small families, couples, and business travelers. Passengers enjoy air-conditioned comfort during their journey. The taxi provides reliable and affordable round-trip transportation. Travelers benefit from convenient sedan travel."
},
{
name: "Round Trip Outstation Cab Navi Mumbai",
description: "Round trip outstation cab Navi Mumbai provides long-distance travel solutions for passengers planning return journeys outside the city. The service is ideal for travel to destinations like Pune, Nashik, Shirdi, Kolhapur, and Goa. Vehicles provide spacious seating and comfortable interiors for extended journeys. Professional drivers ensure safe highway driving and timely pickup services. Families and tourist groups enjoy relaxed travel throughout the trip. The service provides flexible travel duration depending on customer needs. Travelers benefit from dependable outstation round-trip transportation."
}
],

tableData: [
["Round Trip Cab Navi Mumbai","Round Trip Taxi Navi Mumbai"],
["Return Trip Cab Navi Mumbai","Two Way Cab Navi Mumbai"],
["Round Trip Taxi Booking Navi Mumbai","Navi Mumbai Round Trip Cab Service"],
["Cheap Round Trip Taxi Navi Mumbai","Best Round Trip Cab Navi Mumbai"],
["Innova Round Trip Cab Navi Mumbai","Sedan Round Trip Taxi Navi Mumbai"],
["Round Trip Outstation Cab Navi Mumbai","Return Journey Cab Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Local & Highway Drivers",
    WhyChoosedescription: "Our drivers are experienced in both city and long-distance travel from Navi Mumbai. They know the fastest routes, traffic patterns, and highways ensuring a safe and smooth round trip journey."
  },
  {
    WhyChooseheading: "Transparent Round Trip Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for round trip cab bookings in Navi Mumbai. Customers receive clear information about per-kilometer charges, toll costs, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our round trip cab service from Navi Mumbai operates 24 hours a day. Whether you want to travel early morning, during the day, or overnight, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable travel experience for short and long journeys."
  },
  {
    WhyChooseheading: "Flexible Round Trip Travel Options",
    WhyChoosedescription: "We offer flexible round trip cab bookings for city travel, airport transfers, business trips, and outstation journeys from Navi Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and residential societies anywhere in Navi Mumbai for a hassle-free start to your journey."
  },
  {
    WhyChooseheading: "Trusted Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for round trip cab bookings from Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and reliable service."
  }
]
};

const faqData = [
  { question: "Do you provide round trip cab service in Navi Mumbai?", answer: "Yes, Omshree Cabs provides reliable round trip cab services from Navi Mumbai for local travel and outstation journeys." },
  { question: "What is a round trip cab booking?", answer: "A round trip cab booking means the cab picks you up from Navi Mumbai, takes you to your destination, and brings you back to the original location." },
  { question: "Which vehicles are available for round trip travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers." },
  { question: "Is round trip cab service available 24 hours?", answer: "Yes, our round trip cab service operates 24/7 for passenger convenience." },
  { question: "Can I book a round trip cab for outstation travel?", answer: "Yes, round trip cab bookings are available for destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Goa." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest breaks, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide round trip airport transfers?", answer: "Yes, we provide round trip cab services for airport pickup and drop from Navi Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "We booked a round trip cab from Navi Mumbai to Lonavala with Omshree Cabs. The driver was punctual and the entire journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback:
      "Excellent round trip cab service. Clean car, professional driver, and smooth travel experience from Navi Mumbai.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers convenient and reliable round trip cab services in Navi Mumbai. Book Innova, sedan, or other comfortable vehicles for local or outstation round trips with flexible pricing and professional drivers.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Round Trip Cab Navi Mumbai",
    "Round Trip Taxi Booking",
    "Return Trip Cab",
    "Two Way Cab",
    "Innova Round Trip Cab",
    "Sedan Round Trip Taxi",
    "Outstation Round Trip Cab"
  ]
};








  return (
    <div>
      
<Helmet>
  <title>Round Trip Cab Navi Mumbai | Omshree Cab</title>
  <meta
    name="description"
    content="Book a reliable round trip cab in Navi Mumbai with Omshree Cab. Comfortable Innova and sedan vehicles available for local or outstation round trips, ensuring safe and convenient travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Roundtripcabnavimumbai;